import { render, staticRenderFns } from "./ActionsTab.vue?vue&type=template&id=a3268d9e&scoped=true"
import script from "./ActionsTab.vue?vue&type=script&lang=js"
export * from "./ActionsTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3268d9e",
  null
  
)

export default component.exports